class IndexTableFeature {
    ActionButtons = 0
    NamesAsEditPageLinks = 1
}

export default new IndexTableFeature();